import { render } from "./LoginForm.vue?vue&type=template&id=107b1b35"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/LoginForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "107b1b35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('107b1b35', __exports__)) {
    api.reload('107b1b35', __exports__)
  }
  
  module.hot.accept("./LoginForm.vue?vue&type=template&id=107b1b35", () => {
    api.rerender('107b1b35', render)
  })

}


export default __exports__